// /frontend/src/pages/dashboard/post/previews/TikTokPreview.js

import React from 'react';

const PLACEHOLDER = 'https://placehold.co/30x30/000000/FFFFFF?text=TT';

export default function TikTokPreview({
  account,
  files,
  caption,
  postType,
  scheduleDateTime,
}) {
  const main        = files.length ? files[0].url : null;
  const avatar      =
    account?.userAvatar || account?.profileImage || account?.avatarUrl || PLACEHOLDER;
  const displayName = account?.displayName || 'tiktok_user';

  return (
    <div
      className="border rounded bg-white mb-3"
      style={{ width: 200, margin: '0 auto', fontFamily: 'Helvetica, Arial, sans-serif' }}
    >
      {/* header */}
      <div className="d-flex align-items-center p-1">
        <img
          src={avatar}
          alt="avatar"
          className="rounded-circle"
          style={{ width: 24, height: 24, objectFit: 'cover' }}
        />
        <strong className="ms-2" style={{ fontSize: 12 }}>
          {displayName}
        </strong>
      </div>

      {/* media */}
      {main ? (
        <video
          src={main}
          muted
          loop
          style={{ width: '100%', height: 350, objectFit: 'cover' }}
        />
      ) : (
        <div
          className="bg-light d-flex align-items-center justify-content-center"
          style={{ height: 350, color: '#999' }}
        >
          No video selected
        </div>
      )}

      {/* caption */}
      <div className="p-2">
        {caption ? (
          <p className="mb-0" style={{ fontSize: 12, whiteSpace: 'pre-wrap' }}>
            {caption}
          </p>
        ) : (
          <p className="text-muted mb-0" style={{ fontSize: 12 }}>
            Add a caption…
          </p>
        )}
        <small className="text-muted">
          {postType === 'schedule' && scheduleDateTime
            ? `Scheduled · ${new Date(scheduleDateTime).toLocaleString()}`
            : 'Just now'}
        </small>
      </div>
    </div>
  );
}
